import { _, mui, React, ts } from '_core';

type AssetMasterSelectorProps = {
  value: ts.types.widgets.common.BucketValue;
  setValue: (_v: ts.types.widgets.common.BucketValue) => void;
  options: string[];
  disabled?: boolean;
  error?: boolean;
};

const AssetMasterSelector = ({ value, setValue, options, disabled, error }: AssetMasterSelectorProps) => {
  return (
    <mui.core.Grid size={{ xs: 12, md: 6 }}>
      <mui.core.TextField
        select
        label="Asset Master"
        variant="outlined"
        size="small"
        value={value.value}
        onChange={(e) => setValue({ ...value, value: e.target.value })}
        fullWidth
        required
        disabled={disabled}
        error={error}
      >
        {options.map((o) => (
          <mui.core.MenuItem key={o} value={o}>
            {_.startCase(o)}
          </mui.core.MenuItem>
        ))}
      </mui.core.TextField>
    </mui.core.Grid>
  );
};

export default AssetMasterSelector;
